import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { NewTicketPage } from './pages/NewTicketPage';
import { MyTicketsPage } from './pages/MyTicketsPage';
import { TicketDetailPage } from './pages/TicketDetailPage';
import { AdminTicketsPage } from './pages/AdminTicketsPage';
import { AdminTicketDetailPage } from './pages/AdminTicketDetailPage';
import { AffiliatesPage } from './pages/AffiliatesPage';
import { ReferralLandingPage } from './pages/ReferralLandingPage';
import { AffiliateProgramPage } from './pages/AffiliateProgramPage';
import { AffiliateTermsPage } from './pages/AffiliateTermsPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
import { AdminAffiliatesPage } from './pages/AdminAffiliatesPage';
import { AdminAffiliateDetailPage } from './pages/AdminAffiliateDetailPage';
import { AdminSprintPage } from './pages/AdminSprintPage';
import { AdminCRMPage } from './pages/AdminCRMPage';
import { AdminNotesPage } from './pages/AdminNotesPage';
import { AdminCalendarPage } from './pages/AdminCalendarPage';
import { AdminClickUpSettingsPage } from './pages/AdminClickUpSettingsPage';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public */}
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/affiliate-program" element={<AffiliateProgramPage />} />
          <Route path="/affiliate-terms" element={<AffiliateTermsPage />} />
          <Route path="/r/:code" element={<ReferralLandingPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsOfServicePage />} />

          {/* Signed-in users */}
          <Route path="/tickets" element={<ProtectedRoute><MyTicketsPage /></ProtectedRoute>} />
          <Route path="/tickets/new" element={<ProtectedRoute><NewTicketPage /></ProtectedRoute>} />
          <Route path="/tickets/:id" element={<ProtectedRoute><TicketDetailPage /></ProtectedRoute>} />
          <Route path="/affiliates" element={<ProtectedRoute><AffiliatesPage /></ProtectedRoute>} />

          {/* Admin only */}
          <Route path="/admin" element={<Navigate to="/admin/tickets" replace />} />
          <Route path="/admin/tickets" element={<ProtectedRoute requireAdmin><AdminTicketsPage /></ProtectedRoute>} />
          <Route path="/admin/tickets/:id" element={<ProtectedRoute requireAdmin><AdminTicketDetailPage /></ProtectedRoute>} />
          <Route path="/admin/affiliates" element={<ProtectedRoute requireAdmin><AdminAffiliatesPage /></ProtectedRoute>} />
          <Route path="/admin/affiliates/:codeId" element={<ProtectedRoute requireAdmin><AdminAffiliateDetailPage /></ProtectedRoute>} />
          <Route path="/admin/sprint" element={<ProtectedRoute requireAdmin><AdminSprintPage /></ProtectedRoute>} />
          <Route path="/admin/crm" element={<ProtectedRoute requireAdmin><AdminCRMPage /></ProtectedRoute>} />
          <Route path="/admin/notes" element={<ProtectedRoute requireAdmin><AdminNotesPage /></ProtectedRoute>} />
          <Route path="/admin/calendar" element={<ProtectedRoute requireAdmin><AdminCalendarPage /></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute requireAdmin><AdminClickUpSettingsPage /></ProtectedRoute>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

function NotFound() {
  return (
    <div className="app-shell">
      <div className="app-frame" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <div className="terminal-card" style={{ textAlign: 'center', maxWidth: '400px', width: '100%' }}>
          <div className="card-header"><span className="card-num">ERR</span> NOT FOUND</div>
          <div className="card-body">
            <div style={{ fontSize: '4rem', fontWeight: 700, color: 'var(--gold)', marginBottom: '0.5rem' }}>404</div>
            <p style={{ color: 'var(--muted)', marginBottom: '1.5rem', textTransform: 'uppercase', fontSize: '0.875rem' }}>PAGE NOT FOUND</p>
            <a href="/" className="action-btn" style={{ display: 'inline-block', textDecoration: 'none' }}>GO HOME</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;


